var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#292929",
    d: "M2.75 6.41c0-2.848 2.357-5.16 5.25-5.16s5.25 2.312 5.25 5.16c0 1.097-.25 2.263-.737 3.463-.379.934-.905 1.894-1.563 2.859a20.231 20.231 0 01-1.523 1.956c-.322.364-.609.663-.736.783a.991.991 0 01-1.38.002 14.186 14.186 0 01-.739-.788 20.339 20.339 0 01-1.522-1.959A15.438 15.438 0 013.487 9.87c-.488-1.202-.737-2.365-.737-3.46z"
  })), /*#__PURE__*/React.createElement("mask", {
    style: {
      maskType: "alpha"
    },
    id: "a",
    width: 12,
    height: 17,
    x: 2,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    d: "M2.75 6.41c0-2.848 2.357-5.16 5.25-5.16s5.25 2.312 5.25 5.16c0 1.097-.25 2.263-.737 3.463-.379.934-.905 1.894-1.563 2.859a20.231 20.231 0 01-1.523 1.956c-.322.364-.609.663-.736.783a.991.991 0 01-1.38.002 14.186 14.186 0 01-.739-.788 20.339 20.339 0 01-1.522-1.959A15.438 15.438 0 013.487 9.87c-.488-1.202-.737-2.365-.737-3.46z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 6.589,
    r: 2.5,
    stroke: "#292929"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation2);
export default __webpack_public_path__ + "static/media/location2.4fdf8ea6e760cc01d2f6912dd548d452.svg";
export { ForwardRef as ReactComponent };